export default __webpack_public_path__ + "static/media/Axa.f1a4213d.jpeg";